export default __webpack_public_path__ + "static/media/bank.e21dd31b.svg";